import { render } from "./fileDropper.vue?vue&type=template&id=04e94ab1&scoped=true&ts=true"
import script from "./fileDropper.vue?vue&type=script&lang=ts"
export * from "./fileDropper.vue?vue&type=script&lang=ts"

import "./fileDropper.vue?vue&type=style&index=0&id=04e94ab1&scoped=true&lang=css"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e94ab1"]])

export default __exports__